var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFeminism = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Single-Woman-Actions-Flag--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Single Woman Actions Flag Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.63 12.31a0.21 0.21 0 0 0 0 -0.19 0.25 0.25 0 0 0 -0.14 -0.13L12 11.8a0.79 0.79 0 0 1 -0.51 -0.73v-0.47a0.25 0.25 0 0 1 0.25 -0.25 6.33 6.33 0 0 0 3.78 -0.9 0.4 0.4 0 0 0 0.19 -0.27 0.41 0.41 0 0 0 -0.1 -0.32c-0.5 -0.54 -0.84 -1.18 -1 -3.32C14.33 1.72 11.73 0.37 9.5 0.37S4.66 1.72 4.4 5.54c-0.15 2.14 -0.49 2.78 -1 3.32a0.38 0.38 0 0 0 -0.1 0.32 0.36 0.36 0 0 0 0.18 0.27 6.4 6.4 0 0 0 3.78 0.91 0.21 0.21 0 0 1 0.18 0.07 0.23 0.23 0 0 1 0.07 0.18v0.46a0.79 0.79 0 0 1 -0.51 0.73c-2.9 1.06 -5.21 1.82 -5.76 2.92a7.67 7.67 0 0 0 -0.74 2.73 0.37 0.37 0 0 0 0.1 0.3 0.38 0.38 0 0 0 0.29 0.12h11.36a0.25 0.25 0 0 0 0.25 -0.25V13a2 2 0 0 1 0.13 -0.69Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 22.63a1 1 0 0 0 2 0v-3.92a0.24 0.24 0 0 1 0.19 -0.24 3 3 0 0 1 2.44 0.44 4.09 4.09 0 0 0 2.29 0.7 4.31 4.31 0 0 0 1.36 -0.23l0.93 -0.43a0.49 0.49 0 0 0 0.29 -0.45V13a0.5 0.5 0 0 0 -0.23 -0.43 0.51 0.51 0 0 0 -0.48 0l-0.88 0.41a3.06 3.06 0 0 1 -2.72 -0.37 4.05 4.05 0 0 0 -3.59 -0.49l-1.27 0.43A0.5 0.5 0 0 0 14 13Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFeminism);
export default ForwardRef;